import type { IconGlyph } from '@sunwebgroup/ui-components';
import { Icon, Typography, horizontalGap, tk } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${tk('spacing_md')} ${tk('spacing_lg')};

  &:not(:last-child) {
    border-right: 1px solid ${tk('color_palette_grey_300')};
  }

  @media ${tk('mq_desktop_md')} {
    flex-direction: row;
    ${horizontalGap('spacing_xs')}
    padding: unset;

    &:not(:last-child) {
      border-right: unset;
    }
  }
`;

const CategoryIconWrapper = styled.div`
  margin-bottom: ${tk('spacing_xs')};
  @media ${tk('mq_desktop_md')} {
    margin-bottom: unset;
  }
`;

const CategoryIcon = styled(Icon)`
  vertical-align: middle;
  @media ${tk('mq_desktop_md')} {
    ${Icon.modSize('sm')};
  }
`;

const ScoreLabel = styled.div`
  display: flex;
  ${horizontalGap('spacing_xs')}
  text-wrap: nowrap;

  ${Typography} {
    @media ${tk('mq_desktop_md')} {
      text-wrap: unset;
    }
  }
`;

interface CategoryProps {
  icon: IconGlyph;
  score?: number;
  label: string;
}

export function Category({ icon, score, label }: CategoryProps) {
  return (
    <Wrapper>
      <CategoryIconWrapper>
        <CategoryIcon glyph={icon} size="md" />
      </CategoryIconWrapper>
      <ScoreLabel>
        <Typography $variant="body-md-bold">{score?.toFixed(1)}</Typography>
        <Typography $variant="body-md">{label}</Typography>
      </ScoreLabel>
    </Wrapper>
  );
}
